<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">环号：</span>
        <el-input v-model="ringNum" clearable placeholder="请输入环号"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="proId" placeholder="请选择项目名称" clearable>
          <el-option
          v-for="item in projectNameGroup"
          :key="item.proId"
          :label="item.proName"
          :value="item.proId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">入池时间：</span>
        <el-date-picker 
          v-model="putTime" 
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchWaterIntoRecord(true)">查询</el-button>
        <el-button icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content inti_flex">
      <div
        v-for="item in pipeIntoList"
        :key="item.id"
        class="into_item">
        <div class="item_header">
          <span>环号：</span>
          <el-popover
            placement="right"
            trigger="hover"
            popper-class="init_popper">
            <el-table
              :data="item.culRecordListVos"
              height="300">
              <el-table-column prop="sizeName" label="尺寸" align="center"></el-table-column>
              <el-table-column prop="blockNumName" label="块号" align="center"></el-table-column>
              <el-table-column prop="reinforcementName" label="配筋" align="center"></el-table-column>
              <el-table-column prop="turnName" label="转向" align="center"></el-table-column>
              <el-table-column prop="groutingHolesName" label="注浆孔" align="center"></el-table-column>
              <el-table-column prop="diffDescript" label="水养时长" align="center"></el-table-column>
            </el-table>
            <span slot="reference">{{item.ringNum}}</span>
          </el-popover>
        </div>
        <div class="item_content">
          <div class="content_item">
            <span>项目名称：</span>
            <span>{{item.proName}}</span>
          </div>
          <div class="content_item">
            <span>尺寸：</span>
            <span>{{item.sizeName}}</span>
          </div>
          <div class="content_item">
            <span>入池时间：</span>
            <span>{{item.createTime}}</span>
          </div>
          <div class="content_item">
            <span>入池操作人：</span>
            <span>{{item.realName}}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="prop_dialog"
      append-to-body
      title="新增管片"
      :visible.sync="asyncInsert"
      width="35%">
      <el-form ref="form" :model="formInsert" :rules="rulesInsert" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="proId">
          <el-select v-model="formInsert.proId" clearable placeholder="请选择项目" @change="changeProject">
            <el-option
              v-for="item in projectData"
              :key="item.proId"
              :label="item.proName"
              :value="item.proId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管片环号：" prop="ringNums">
          <el-select v-model="formInsert.ringNums" clearable multiple filterable placeholder="请选择管片环号" @change="changeRing">
            <el-option
              v-for="item in ringNumData"
              :key="item.ringNum"
              :label="item.ringNum"
              :value="item.ringNum">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水养池：" prop="waterCultivatedId" class="row_flex">
          <el-select v-model="formInsert.waterCultivatedId" clearable placeholder="请选择水养池" @change="changeWaterCultivated">
            <el-option
              v-for="item in waterCuringData"
              :key="item.waterCultivatedId"
              :label="item.waterCultivatedName"
              :value="item.waterCultivatedId">
            </el-option>
          </el-select>
          <div class="water_info">
            <div>
              <span>最大容量：</span>
              <span>
                {{maxSize}}<span>环</span>
              </span>
            </div>
            <div>
              <span>实际存放：</span>
              <span>
                {{currentCount}}<span>环</span>
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="预计完成水养时间：" prop="expectTime">
          <el-date-picker
            v-model="formInsert.expectTime"
            type="datetime"
            placeholder="请选择预计完成水养时间"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <div class="main_content">
          <el-table
            class="form_table"
            :data="ringDataList"
            height="230">
            <el-table-column label="序号" width="60" align="center">
              <template #default="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="blockNum" label="块号" align="center"></el-table-column>
            <el-table-column prop="pipeNum" label="管片编号" align="center"></el-table-column>
            <el-table-column prop="checkTime" label="质检时间" align="center"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncInsert = false">取 消</el-button>
        <el-button class="submit_btn" @click="submitInsertWater()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { throttle } from '../../../plugins/public';
  export default {
    name: 'IntoRecord',
    props: {
      waterId: {
        type: String
      }
    },
    data() {
      return {
        ringNum: '',
        proId:'',
        putTime: '',
        projectNameGroup:[],//项目名称
        pipeIntoList: [],
        asyncInsert: false,
        formInsert: {},
        rulesInsert: {
          proId: [{
            required: true,
            message: '请选择项目',
            trigger: ['change', 'blur']
          }],
          ringNums: [{
            required: true,
            message: '请选择环号',
            trigger: ['change', 'blur']
          }],
          waterCultivatedId: [{
            required: true,
            message: '请选择水养池',
            trigger: ['change', 'blur']
          }],
          expectTime: [{
            required: true,
            message: '请选择预计完成水养时间',
            trigger: ['change', 'blur']   
          }]
        },
        projectData: [],
        ringNumData: [],
        waterCuringData: [],
        ringDataList: [],
        currentCount: 0,
        maxSize: 0
      }
    },
    mounted() {
      this.getAllProjectData();
      this.searchWaterIntoRecord();
    },
    methods: {
      // 获取全部项目
      async getAllProjectData() {
        const { data } = await this.$api.Engineer.getAllProjects();
        this.projectData = data;
        this.projectNameGroup = data;
      },
      // 获取全部水养池
      async getWaterCultivatedData() {
        const { data } = await this.$api.DuctpiecePLM.getWaterCultivatedData();
        this.waterCuringData = data;
      },
      // 查询入池记录
      searchWaterIntoRecord() {
        this.$api.DuctpiecePLM.searchWaterIntoRecord({
          waterCultivatedId: this.waterId,
          ringNum: this.ringNum,
          proId: this.proId,
          strTime: this.putTime ? this.putTime[0] : '',
          endTime: this.putTime ? this.putTime[1] : ''
        }).then((res) => {
          if(res.success) {
            this.pipeIntoList = res.data;
          }
        })
      },
      // 打开新增管片
      propInsert() {
        this.asyncInsert = true;
      },
      // 选择项目
      changeProject(data) {
        this.ringNumData = [];
        this.ringDataList = [];
        this.$set(this.formInsert, 'ringNums', '');
        this.$refs.form.clearValidate('ringNums');
        if(data) {
          this.$api.DuctpiecePLM.getProjectRingNumWaterData({
            proId: data
          }).then(res => {
            this.ringNumData = res.data.map(item => {
              return {
                ringNum: item
              }
            })
          });
          this.$api.DuctpiecePLM.getProjectRingPipeData({
            proId: data,
            ringNums: this.formInsert.ringNums
          }).then(res => {
            if(res.success) {
              this.ringDataList = res.data;
            } else {
              this.ringDataList = [];
              this.$message.warning(res.statusMsg);
            }
          })
        }
      },
      // 选择环号
      changeRing(data) {
        if(data) {
          this.$api.DuctpiecePLM.getProjectRingPipeDatas({
            proId: this.formInsert.proId,
            ringNums: data
          }).then(res => {
            if(res.success) {
              this.ringDataList = res.data;
            } else {
              this.ringDataList = [];
              this.$message.warning(res.statusMsg);
            }
          })
        } else {
          this.ringDataList = [];
        }
      },
      // 选择水养池
      changeWaterCultivated(data) {
        if(data) {
          const dataInfo = this.waterCuringData.find(item => item.waterCultivatedId === data);
          this.currentCount = dataInfo.currentCount;
          this.maxSize = dataInfo.maxSize;
        } else {
          this.currentCount = 0;
          this.maxSize = 0;
        }
      },
      // 提交入池信息
      submitInsertWater: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formInsert);
            this.$api.DuctpiecePLM.submitpipeEnterCistern(params).then((res) => {
              if(res.success) {
                this.asyncInsert = false;
                this.$message.success('添加成功！');
                this.searchWaterIntoRecord();
              } else {
                this.$message.warning(res.statusMsg); 
              }
            })
          }
        })
      }, 3000),
    },
    watch: {
      asyncInsert(bol) {
        if(bol) {
          this.$set(this.formInsert, 'ringNums', []);
          this.getAllProjectData();
          this.getWaterCultivatedData();
        } else {
          this.currentCount = 0;
          this.maxSize = 0;
          this.ringDataList = [];
          this.formInsert = {};
          this.$set(this.formInsert, 'ringNums', []);
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';

.main {
  height: 100% !important;
  background: none !important;
}

.row_flex {

  /deep/.el-form-item__content {
    display: flex;
    flex-direction: column;
  }

  .water_info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 10px;
    color: #FFFFFF;
    background: #093C62; 
    border-radius: 4px;

    & span:last-child {
      color: #18F7F9;
      font-size: 18px;
      font-weight: 600;

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}

.form_table {
  background: #0D1846;
}

.inti_flex {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto !important;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px transparent;
      background: rgba(8, 81, 114, .8);
  }

  &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px transparent;
      border-radius: 10px;
      background: rgba(8, 81, 114, .4) 5%,;
  }

  .into_item {
    margin: 10px;
    width: calc((100% / 4) - 20px);
    height: fit-content;
    height: 185px;
    background: #0C2E5E;
    border: 1px solid #39B5FE;
    border-radius: 4px;

    .item_header {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      font-size: 16px;
      color: #FFFFFF;
      background: #19538B;
      border-radius: 4px 4px 0 0;

      & > span:last-child {
        color: #39B5FE;
      }
    }

    .item_content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 5px 0;

      .content_item {
        margin: 5px 15px;
        color: #E1E6EB;

        & > span:first-child {
          display: inline-block;
          width: 90px;
          color: #BAC4D2;
        }
      }
    }
  }
}


::v-deep .el-input--small .el-input__inner {
  color: #EAEAEA;
  background: #061C48;
  border:  1px solid #1B428F;
}

::v-deep .el-table tr {
  background: transparent !important;

  &:nth-of-type(even) {
    background: #082E56 !important;
  }
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: rgba($color: #34AFED, $alpha: .5);
}
</style>
<style lang="scss">
  .init_popper {
    background: #061C48;
    
    .el-table {
      background: #061C48;
    }

    .el-table tr {
      background: transparent !important;

      &:nth-of-type(even) {
        background: #082E56 !important;
      }
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
      background: rgba($color: #34AFED, $alpha: .5);
    }
  }
</style>